import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useRef } from 'react'

export function Dialog({ children }: { children: React.ReactNode }) {
    const dialogRef = useRef<HTMLDialogElement>(null)
    let trigger: React.ReactNode = null
    let content: React.ReactNode = null
    const childArray = Array.isArray(children) ? children : [children]
    childArray.forEach((child: any) => {
        if (child?.type === DialogTrigger) trigger = child
        if (child?.type === DialogContent) content = child
    })
    return (
        <>
            <dialog
                ref={dialogRef}
                className='dialog'
                onClick={(e) => {
                    if (e.target === e.currentTarget) dialogRef.current?.close()
                }}
            >
                <div className='dialog-content'>
                    <button className='dialog-close-button' onClick={() => dialogRef.current?.close()}>
                        <FontAwesomeIcon icon={faClose} />
                    </button>
                    {content}
                </div>
            </dialog>
            <div className='cursor-pointer' onClick={() => dialogRef.current?.showModal()}>
                {trigger}
            </div>
        </>
    )
}

function DialogTrigger({ children }: { children: React.ReactNode }) {
    return <>{children}</>
}

function DialogContent({ children }: { children: React.ReactNode }) {
    return <>{children}</>
}

Dialog.Trigger = DialogTrigger
Dialog.Content = DialogContent
